<script>
import moment from 'moment/moment';
import {Icon} from '@iconify/vue';

/* MIXINS */
import blockadeReasonsConst from '@mixins/const/blockadeReasonsConst';
import reservationTypesConst from '@mixins/const/reservationTypesConst';
import permissionsMixin from '@mixins/permissionsMixin';
import sidebarMixin from '@mixins/sidebarMixin';
import prestationTypesConst from '../../mixins/const/prestationTypesConst';

export default {
  components: {},
  mixins: [permissionsMixin, sidebarMixin, prestationTypesConst],
  props: {
    blockade: {
      type: Object,
      required: true,
    },
    firstDate: {
      required: true,
    },
    endDate: {
      required: true,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  computed: {
    styleReservation() {
      let colStart = 0;
      if (moment(this.blockade.dateStart).isSameOrBefore(moment(this.firstDate))) {
        colStart = 1;
      } else {
        colStart = moment(this.blockade.dateStart).diff(moment(this.firstDate), 'days') + 1;
      }

      let colEnd = 0;
      if (moment(this.blockade.dateEnd).isSameOrAfter(moment(this.endDate))) {
        colEnd = -1;
      } else {
        colEnd = moment(this.blockade.dateEnd).diff(moment(this.firstDate), 'days') + 2;
      }
      return 'grid-column : ' + colStart + ' / ' + colEnd;
    },
  },
};
</script>

<template>
  <div class="overflow-hidden prestation-slot unavailable h-full" :style="this.styleReservation"></div>
</template>
